// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2eIcR","title":"Header_title__3Ijok","side":"Header_side__183qs"};